import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "components/shared/toast/toast";
import { FORM } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";
import { makeQueryString, traverseTree, updateTree } from "utils/utils";

const initialState = {
  droppedItems: [],
  form: [],
  toggle: {},
  dependentId: 0,
  formId: "",
  lastDroppedItemId: null,
  selectedName: "",
  selectedData: null,
  rightPanelSectionData: null,
  preReviewModalOpen: false,
  isFetching: false,
  pageNumber: 1,
  pageSize: 10,
  totalCount: 0,
  configure: {},
  aiformdata: {},
  Loading: false,
};

export const getFormsData = createAsyncThunk(
  "forms/getFormData",
  async (payload, { rejectWithValue, dispatch, signal }) => {
    try {
      const queryString = makeQueryString(FORM, payload);
      const { data } = await privateGet(queryString, { signal });
      dispatch(setPageNumber(payload.pageNumber));
      dispatch(setPageSize(payload.limit));
      return {
        forms: data?.data?.forms || [],
        totalCount: data?.data?.totalForms || 0,
      };
    } catch (error) {
      rejectWithValue(error);
      return error;
    }
  }
);

const formSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setDependentId: (state, action) => {
      state.dependentId = action.payload;
    },
    setFormId: (state, action) => {
      state.formId = action.payload;
    },
    setConfigure: (state, action) => {
      state.configure = action.payload;
    },
    setLoading: (state, action) => {
      state.Loading = action.payload;
    },
    setAiformdata: (state, action) => {
      // const { id, data } = action.payload;
      // state.aiformdata = {
      //   ...state.aiformdata,
      //   [id]: data,
      state.aiformdata = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.pageNumber = 1;
    },
    setToggle: (state, action) => {
      const sectionId = action.payload;
      state.toggle = {
        ...state.toggle,
        [sectionId]: !state.toggle[sectionId],
      };
    },
    setToggleCheck: (state, action) => {
      const { sectionId, value } = action.payload;
      state.toggle = {
        ...state.toggle,
        [sectionId]: value,
      };
    },
    setDroppedItems: (state, action) => {
      state.droppedItems = action.payload;
    },
    setLastDroppedItemId: (state, action) => {
      state.lastDroppedItemId = action.payload;
    },
    setUpdateDroppedItems: (state, action) => {
      const { id, updatedData } = action.payload;

      // Update the droppedItems array
      state.droppedItems = updateTree(state?.droppedItems, updatedData, id)
    },

    setSelectedName: (state, action) => {
      state.selectedName = action.payload;
    },
    setSelectedData: (state, action) => {
      state.selectedData = action.payload;
    },
    setRightPanelSectionData: (state, action) => {
      state.rightPanelSectionData = action.payload;
    },
    setPreReviewModalOpen: (state, action) => {
      state.preReviewModalOpen = action.payload;
    },
  },
  extraReducers: {
    [getFormsData.pending]: (state) => {
      state.isFetching = true;
    },
    [getFormsData.fulfilled]: (state, action) => {
      state.form = action.payload.forms;
      state.totalCount = action.payload.totalCount;
      state.isFetching = false;
    },
    [getFormsData.rejected]: (state) => {
      state.isFetching = false;
    },
  },
});

export const {
  setDroppedItems,
  setLastDroppedItemId,
  setUpdateDroppedItems,
  setSelectedName,
  setSelectedData,
  setRightPanelSectionData,
  setPreReviewModalOpen,
  setToggle,
  setDependentId,
  setToggleCheck,
  setPageNumber,
  setPageSize,
  setFormId,
  setConfigure,
  setAiformdata,
  setLoading
} = formSlice.actions;
export default formSlice.reducer;
